import { md5 } from 'tiny-hashes';

export default (email) => {
  return `https://www.gravatar.com/avatar/${md5(email)}?d=404`;
};
